import type { MagentoApiGetPromoGiftInfoQueryResponse } from "@jti/magento-api-v2";

import type { MagentoApiBuilder } from "../magentoApiSlice";

export type PromoGiftInfo = {
  sku: string;
  imageUrl: string;
  selectedOption?: string;
};

type BundleProductItem = Extract<
  NonNullable<NonNullable<MagentoApiGetPromoGiftInfoQueryResponse["products"]>["items"]>[number],
  { __typename?: "BundleProduct" }
>;

export const getPromoGiftInfoEndpoint = (builder: MagentoApiBuilder) => ({
  getPromoGiftInfo: builder.query<PromoGiftInfo[], { skus: string[] }>({
    query: ({ skus }) => ({
      method: "getPromoGiftInfo",
      params: [{ sku: skus }],
    }),
    transformResponse: (response: MagentoApiGetPromoGiftInfoQueryResponse): PromoGiftInfo[] => {
      const items = response?.products?.items ?? [];

      return items
        .filter((item): item is NonNullable<typeof item> => item !== null && item.sku !== null)
        .map((item) => {
          const imageUrl = item.image?.url ?? "";

          let selectedOption: string | undefined;
          if ("items" in item) {
            const bundleItem = item as BundleProductItem;
            const firstBundleItem = bundleItem.items?.[0];
            const defaultOption = firstBundleItem?.options?.find((opt) => opt?.is_default);
            const firstOption = defaultOption ?? firstBundleItem?.options?.[0];
            selectedOption = firstOption?.uid ?? undefined;
          }

          return { sku: item.sku!, imageUrl, selectedOption };
        });
    },
  }),
});
